export default [
  // Authenticated routes.
  ...middleware('auth', [
    { path: '/', name: 'home', component: require('~/pages/home_secondary').default },
    {
      path: '/verifications/contracts',
      component: require('~/pages/verifications/VerificationList').default,
      name: 'verifications.verifications'
    },
    {
      path: '/verifications/contracts/:id',
      component: require('~/pages/verifications/VerificationDetail').default,
      name: 'verifications.verification_detail'
    },
    {
      path: '/verifications/kam/:id',
      component: require('~/pages/verifications/KamVerificationDetail').default,
      name: 'verifications.kam_verification_detail'
    },
    {
      path: '/verifications-new/contracts',
      component: require('~/pages/verifications/VerificationNewList').default,
      name: 'verifications.new_verifications'
    },
    {
      path: '/verifications-new/contracts/:id/:year/:kam/:address',
      component: require('~/pages/verifications/VerificationNewDetail').default,
      name: 'verifications.new_verification_detail'
    },
    {
      path: '/analysis',
      component: require('~/pages/analysis/List').default,
      name: 'analysis.list'
    },
    {
      path: '/contracts',
      component: require('~/pages/contracts/List').default,
      name: 'contracts.list'
    },
    {
      path: '/customers',
      component: require('~/pages/customers/List').default,
      name: 'customers.list'
    },
    {
      path: '/customers/:id',
      component: require('~/pages/customers/Detail').default,
      name: 'customers.detail'
    },
    {
      path: '/customer_logins',
      component: require('~/pages/customer_logins/List').default,
      name: 'customer_logins.list'
    },
    {
      path: '/customer_logins/:id',
      component: require('~/pages/customer_logins/Detail').default,
      name: 'customer_logins.detail'
    },
    {
      path: '/analysis/:id',
      component: require('~/pages/analysis/Detail').default,
      name: 'analysis.detail'
    },
    {
      path: '/settings', component: require('~/pages/settings/index').default,
      children: [
        { path: '', redirect: { name: 'settings.profile' }},
        { path: 'profile', name: 'settings.profile', component: require('~/pages/settings/profile').default },
        { path: 'password', name: 'settings.password', component: require('~/pages/settings/password').default }
      ]
    }
  ]),

  // Guest routes.
  ...middleware('guest', [
    { path: '/login', name: 'login', component: require('~/pages/auth/login').default },
    { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email').default },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      component: require('~/pages/auth/password/reset').default
    }
  ]),

  { path: '*', component: require('~/pages/errors/404.vue').default }
]

/**
 * @param  {String|Function} middleware
 * @param  {Array} secondaryRoutes
 * @return {Array}
 */
function middleware (middleware, secondaryRoutes) {
  secondaryRoutes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  )

  return secondaryRoutes
}
